import React from "react";
import Typography from "@material-ui/core/Typography";
import { rgbToHex } from "@material-ui/core/styles/colorManipulator";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  container: {
    display: "flex",
    width: "100%"
  },
  colorSquare: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row"
  }
});

function ColorBar({
  theme,
  color,
  classes,
  variants = ["dark", "main", "light"]
}) {
  const background = typeof color === "string" ? { main: color } : color;
  let augBg = theme.palette.augmentColor(background);

  return (
    <div className={classes.container}>
      {variants.map(key => (
        <Typography
          className={classes.colorSquare}
          style={{
            height: "24px",
            width: Math.round(100 / variants.length) + "%",
            color: theme.palette.getContrastText(augBg[key]),
            backgroundColor: augBg[key]
          }}
          key={key}
          variant="caption"
        >
          {rgbToHex(augBg[key])}
        </Typography>
      ))}
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(ColorBar);
